import RootState from 'typings/RootState'
import { Event } from '../../types/event'
import { DataList } from './types'

export const selectEvent = (state: RootState): Event =>
  state.adminReportPerformance.Event

export const selectReportList = (state: RootState): DataList =>
  state.adminReportPerformance.DataList

export const selectFilter = (state: RootState) =>
  state.adminReportPerformance.Filter

export const selectSorting = (state: RootState) =>
  state.adminReportPerformance.sorting

export const selectInitFilter = (state: RootState) =>
  state.adminReportPerformance.ClearFilter
